import { useEffect } from 'react';
import { Download, X } from 'lucide-react';

/**
 * Bild-Ansicht über dem Drawer (fixed Overlay, z-50): großes Bild,
 * Esc/Backdrop schließt, Download-Button. Die Blob-URL gehört dem
 * Aufrufer (Thumbnail) — hier nur anzeigen, kein eigenes Fetching.
 */
export function InvoiceImageLightbox({
  url, fileName, onClose,
}: {
  url: string;
  fileName: string | null;
  onClose: () => void;
}) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose]);

  const handleDownload = () => {
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName || 'anlage';
    a.click();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/80 p-8" onClick={onClose}>
      <button
        type="button"
        onClick={onClose}
        title="Schließen (Esc)"
        className="absolute right-4 top-4 rounded-full bg-white/90 p-2 text-gray-700 hover:bg-white"
      >
        <X className="h-5 w-5" />
      </button>
      <button
        type="button"
        onClick={handleDownload}
        title="Herunterladen"
        className="absolute bottom-4 right-4 rounded-full bg-white/90 p-2 text-gray-700 hover:bg-white"
      >
        <Download className="h-5 w-5" />
      </button>
      {/* stopPropagation: Klick aufs Bild schließt nicht (Backdrop-Klick schon). */}
      <img
        src={url}
        alt={fileName ?? 'Anlage'}
        onClick={(e) => e.stopPropagation()}
        className="max-h-full max-w-full rounded-lg object-contain shadow-2xl"
      />
    </div>
  );
}